<template lang="pug">
  .content.overflow-visible.max-height-initial.page.necessary
    .edit-select.necessary__select
      select.select(@change="changeEditSelect")
        option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
    e-form-tabs.edit-tabs.necessary__tabs(
      v-model="tabView"
      :tabs="tabs"
      @input="changeOperator"
    )
    .tabs-content
      .necessary__buttons(v-if="hasNecessaryPlannedItems" )
        button.reset-btn.button(v-for="item in includedTabs" :key="item.id" @click="includedTabsView=item.id"  :class="{button_blue:includedTabsView===item.id}" ) {{item.name}}
      .tabs-content
        div(v-if="includedTabsView === 'count'  && !hasEstimatedQuantityTab" )
          .necessary__action-block
            .necessary__form
              div
                label.label.form-group__label.semibold Необходимое количество МСиН
                e-input.form__elem_input(
                  name="msn_count"
                  inputType="input"
                  :model="fields"
                  :disabled="true"
                )
              div
                label.label.form-group__label.semibold Необходимое количество емкостей
                e-input.form__elem_input(
                  name="containers_count"
                  inputType="input"
                  :model="fields"
                  :disabled="true"
                )
              div
                label.label.form-group__label.semibold Год
                select.select.e-year-select(v-model="year" @change="$emit('onSelectItem',year)")
                  option(v-for="option in yearsOptions" :value="option.id") {{option.name}}
              button.button.button_usual(@click='getMsnDeficit') Рассчитать
            .necessary__buttons
              e-button-add(
                btnDefaultClass="button_add button button_icon"
                @click="showAddOperator = true"
                title="Добавить целевой показатель"
              )
              button.reset-btn.button.button_delete.button_icon(
                v-if="operatorInput"
                @click="deleteItem"
              )
          .table.necessary__table
            .table__row
              .table__col.table__head.table__col_small Номер
              .table__col.table__head Наименование
              .table__col.table__head.table__col_small Источник
              .table__col.table__head.table__col_small Единица измерения
              .table__col.table__head.table__col_small.necessary__years(v-for="year in years")
                .necessary__year
                  span.necessary__year-text {{ year }}
                .necessary__year-row
                  .necessary__year-col План
                  .necessary__year-col Факт
            .table__row(v-for="(item, index) in targets")
              .table__col.table__data.table__col_small
                .custom-radio
                  label.custom-radio__label
                    input.visually-hidden.custom-radio__input(name="operator-input" :value="item.id" type="radio" v-model="operatorInput")
                    .custom-radio__block
                    .custom-radio__text № {{ index + 1 }}
              .table__col.table__data  {{ item.name }}
              .table__col.table__data.table__col_small  {{ getValue(item.source)}}
              .table__col.table__data.table__col_small  {{ item.measure ? getValue(item.measure.name) : '-'}}
              .table__col.table__head.table__col_small.necessary__year-values-col(v-for="year in years")
                .necessary__year-values(title="Чтобы отредактировать значение используйте двойной клик" :class="{hasError:errors[`${item.id}_${year}_fact`] || errors[`${item.id}_${year}_plan`]}")
                  .necessary__year-value
                    span(
                      v-if="tariffByYear[item.id][year] && !tariffByYear[item.id][year].isEditPlan"
                      @dblclick="setEdit(item, year, 'isEditPlan')"
                    ) {{tariffByYear[item.id][year]? getValue(tariffByYear[item.id][year].plan) : '-' }}
                    span(
                      v-if="tariffByYear[item.id][year] && tariffByYear[item.id][year].isEditPlan"
                      title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                    )
                      input.input(
                        v-model="tariffByYear[item.id][year].plan"
                        @blur="saveEdit(item, year, 'plan')"
                        @keyup.enter.prevent="saveEdit(item, year, 'plan')"
                      )
                    span.necessary__error(v-if="errors[`${item.id}_${year}_plan`]") {{errors[`${item.id}_${year}_plan`]}}
                  .necessary__year-value
                    span(
                      v-if="tariffByYear[item.id][year] && !tariffByYear[item.id][year].isEditFact"
                      @dblclick="setEdit(item, year, 'isEditFact')"
                    ) {{tariffByYear[item.id][year]? getValue(tariffByYear[item.id][year].fact) : '-' }}
                    span(
                      v-if="tariffByYear[item.id][year] && tariffByYear[item.id][year].isEditFact"
                      title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                    )
                      input.input(
                        v-model="tariffByYear[item.id][year].fact"
                        @blur="saveEdit(item, year, 'fact')"
                        @keyup.enter.prevent="saveEdit(item,year,'fact')"
                      )
                    span.necessary__error(v-if="errors[`${item.id}_${year}_fact`]") {{errors[`${item.id}_${year}_fact`]}}
          target-update(
            v-if="showAddOperator"
            :isFromOperator="true"
            :tko_operator_id="tko_operator_id"
            @closeModalOperator="closeModalOperator"
          )
        estimated-quantity-tab(v-if="includedTabsView === 'count' && hasEstimatedQuantityTab" :tko_operator_id="tko_operator_id")
        planned-tab(v-if="includedTabsView === 'planned' && !hasPlannedPurchasesTab" :tko_operator_id="tko_operator_id")
        planned-purchases-tab(v-if="includedTabsView === 'planned' && hasPlannedPurchasesTab" :tko_operator_id="tko_operator_id")
</template>
<script>
import { core, indicator, tko, msn } from '@/api/api-endpoints'
import { typeTable, ValueModel } from '@/mixins/targetMixin'
import TargetUpdate from '@/app/target/TargetUpdate'
import year from '@/utils/year'
import yearHelper from '@/utils/year'
import hasMixin from '@/mixins/has-mixin'

import PlannedTab from './components/plannedTab.vue'
import EstimatedQuantityTab from '@/app/msn/components/estimatedQuantityTab'
import PlannedPurchasesTab from '@/app/msn/components/plannedPurchasesTab.vue'

const enumType = {
  plan: 'isEditPlan',
  fact: 'isEditFact',
}
export default {
  components: {
    EstimatedQuantityTab,
    TargetUpdate,
    PlannedTab,
    PlannedPurchasesTab,
  },
  mixins: [hasMixin],
  data: () => ({
    tabs: [],
    targets: [],
    tabView: 'tab1',
    tabOperators: {},
    operatorInput: null,
    showAddOperator: false,
    showAddPlans: false,
    tko_operator_id: null,
    lastYear: 1990,
    years: [],
    tariffByYear: {},
    errors: {},
    fields: {
      containers_count: '',
      msn_count: '',
    },
    includedTabsView: 'count',
    year: year.getCurrentYear(),
  }),
  computed: {
    includedTabs() {
      const tabs = [{ id: 'count', name: 'Расчетное количество' }]
      if (this.hasNecessaryPlannedItems) {
        tabs.push({ id: 'planned', name: 'Планируемое к приобретению' })
      }
      return tabs
    },
    yearsOptions() {
      return yearHelper.getSpecifiedYearsOptions(2023, 2032, false)
    },
  },
  methods: {
    async getOperators() {
      const operators = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.regionalOperators(),
        })
      ).data.data
      this.tabs = operators.map((item, index) => {
        const tabName = `tab${index + 1}`
        this.tabOperators[tabName] = { id: item.id }
        return {
          [tabName]: item.only_name,
        }
      })
      this.getTargets(operators[0].id)
      this.tko_operator_id = operators[0].id
    },
    async getTargets(tko_operator_id) {
      this.targets = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.objects({
            query: {
              tko_operator_id,
              type_table: typeTable.OPERATOR_TABLE,
            },
          }),
        })
      ).data.data

      this.getYears()
    },
    async getCollection() {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: core.collection('measure', {
          query: {
            type: 'indicator',
          },
        }),
      })
    },
    async deleteItem() {
      await this.$store.dispatch('deleteModel', {
        url: indicator.objectDeleteWithOperator(
          this.operatorInput,
          this.tko_operator_id
        ),
      })
      this.getTargets(this.tko_operator_id)
    },
    async saveEdit(item, year, type) {
      const tko_operator_id = this.tko_operator_id
      const value = this.tariffByYear[item.id][year][type]

      try {
        await this.$store.dispatch('updateModel', {
          url: indicator.objectPlanFactUpdate(item.id, year, {
            query: { tko_operator_id },
          }),
          data: {
            id: item.id,
            [type]: value,
            value,
            year,
          },
        })
        this.tariffByYear[item.id][year][enumType[type]] = false
        this.$delete(this.errors, `${item.id}_${year}_plan`)
        this.$delete(this.errors, `${item.id}_${year}_fact`)
      } catch (e) {
        const errors = JSON.parse(this.$store.getters.getError.message)
        if (errors.plan) {
          this.$set(this.errors, `${item.id}_${year}_plan`, errors.plan)
        }
        if (errors.fact) {
          this.$set(this.errors, `${item.id}_${year}_fact`, errors.fact)
        }
      }
    },
    async sendYear(year) {
      await this.$store.dispatch('createModel', {
        url: indicator.objectEmptyTableTypeYear(
          year,
          typeTable.OPERATOR_TABLE,
          {
            query: { tko_operator_id: this.tko_operator_id },
          }
        ),
        data: {},
      })
      this.getTargets(this.tko_operator_id)
    },
    async getMsnDeficit() {
      const data = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: msn.deficit({
            query: { tko_operator_id: this.tko_operator_id, year: this.year },
          }),
        })
      ).data
      this.fields.msn_count = data.msn_count
      this.fields.containers_count = data.containers_count
    },
    deleteYear(year) {
      this.$e
        .confirmBox(
          'Колонка будет удалена, если в ней не были заданы значения',
          'Удалить колонку?'
        )
        .then(async () => {
          await this.$store.dispatch('deleteModel', {
            url: indicator.objectDeleteEmptyYear(
              year,
              typeTable.OPERATOR_TABLE,
              {
                query: { tko_operator_id: this.tko_operator_id },
              }
            ),
            data: {},
          })
          const yearIndex = this.years.findIndex((item) => item === year)
          this.years.splice(yearIndex, 1)
        })
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
    changeOperator(val) {
      this.tko_operator_id = this.tabOperators[val]?.id
      this.fields.msn_count = ''
      this.fields.containers_count = ''
      if (this.tko_operator_id) {
        this.getTargets(this.tko_operator_id)
      }
    },
    getYears() {
      this.targets.forEach((item) => {
        this.$set(this.tariffByYear, item.id, {})
        item.values.forEach((el) => {
          this.years.push(el.year)
          this.$set(this.tariffByYear[item.id], el.year, {
            plan: el.plan,
            fact: el.fact,
            isEditPlan: false,
            isEditFact: false,
          })
          if (this.lastYear < el.year) {
            this.lastYear = el.year
          }
        })
        Object.values(this.tariffByYear).forEach((el) => {
          this.years.forEach((year) => {
            if (!el[year]) {
              this.$set(this.tariffByYear[item.id], year, {
                plan: null,
                fact: null,
                isEditPlan: false,
                isEditFact: false,
              })
            }
          })
        })
      })
      this.years = Array.from(new Set(this.years))
    },
    getValue(name) {
      return name ? name : '-'
    },
    closeModalOperator() {
      this.showAddOperator = false
      this.getTargets(this.tko_operator_id)
    },
    addNewCol() {
      let newCol = new ValueModel(this.lastYear + 1)
      this.years.push(newCol.year)
      this.sendYear(newCol.year)
    },
    setEdit(item, year, type) {
      this.tariffByYear[item.id][year][type] =
        !this.tariffByYear[item.id][year][type]
    },
  },
  created() {
    this.getOperators()
    this.getCollection()
  },
}
</script>
<style lang="scss" scoped>
.necessary {
  &__buttons {
    display: flex;
    gap: 10px;
  }
}
</style>
